export const DAY_IN_MILLISECONDS = 1000 * 60 * 60 * 24

export function setWithExpiry(key, value, ttl) {
  try {
    const now = new Date()

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
      value,
      expiry: now.getTime() + ttl,
    }
    localStorage.setItem(key, JSON.stringify(item))
  } catch (e) {
    // do nothing
  }
}

export function getWithExpiry(key) {
  try {
    const itemStr = localStorage.getItem(key)
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
    // compare the expiry time of the item with the current time
    if (item.expiry === undefined || now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key)
      return null
    }
    return item.value
  } catch (e) {
    return null
  }
}

export function setWithExpiryDate(key, value, expiryDate) {
  try {
    const item = {
      value,
      expiry: new Date(expiryDate).getTime(),
    }
    localStorage.setItem(key, JSON.stringify(item))
  } catch (e) {
    // do nothing
  }
}

export function getWithExpiryDate(key) {
  try {
    const itemStr = localStorage.getItem(key)
    if (!itemStr) {
      return null
    }

    const item = JSON.parse(itemStr)

    // Parse expiry to ensure it's a date object and compare it with current time
    const now = new Date()
    const expiryDate = new Date(item.expiry)

    // Compare the expiry date of the item with the current date
    if (item.expiry === undefined || now > expiryDate) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key)
      return null
    }

    return item.value
  } catch (e) {
    return null
  }
}
